import { DateTime } from 'luxon'

const getNotificationDateFormat = (locale = '') =>
  locale.toLowerCase().startsWith('de') ? 'dd.MM.yyyy' : 'dd LLL yyyy'

const normalizeAbbreviatedMonth = (value = '') => {
  const [day = '', month = '', year = ''] = value.split(' ')
  const monthWithoutDots = month.replace(/\./g, '')
  const normalizedMonth =
    monthWithoutDots.charAt(0).toUpperCase() + monthWithoutDots.slice(1)

  return [day, normalizedMonth, year].filter(Boolean).join(' ')
}

export const defineDateText = (date, formatMessage, locale = 'en') => {
  if (!date) {
    return ''
  }

  const dateNow = DateTime.now().setLocale(locale)
  const notificationDate = DateTime.fromISO(date).setLocale(locale)

  if (!notificationDate.isValid) {
    return ''
  }

  if (notificationDate > dateNow.minus({ minutes: 1 })) {
    return formatMessage({ id: 'just_now' })
  }

  if (notificationDate > dateNow.minus({ hours: 1 })) {
    const diffMinutes = Math.floor(
      dateNow.diff(notificationDate, 'minutes').minutes
    )
    return formatMessage({ id: 'date_minutes_ago' }, { value: diffMinutes })
  }

  if (notificationDate > dateNow.minus({ days: 1 })) {
    const diffHours = Math.floor(dateNow.diff(notificationDate, 'hours').hours)
    return formatMessage({ id: 'date_hours_ago' }, { value: diffHours })
  }

  if (notificationDate.hasSame(dateNow.minus({ days: 1 }), 'day')) {
    return formatMessage(
      { id: 'date_yesterday' },
      { value: notificationDate.toFormat('HH:mm') }
    )
  }

  if (notificationDate.hasSame(dateNow, 'week')) {
    return `${notificationDate.toFormat('cccc')}, ${notificationDate.toFormat('HH:mm')}`
  }

  const formattedDate = notificationDate.toFormat(
    getNotificationDateFormat(locale)
  )

  if (locale.toLowerCase().startsWith('de')) {
    return formattedDate
  }

  return normalizeAbbreviatedMonth(formattedDate)
}
